import { ItemProps } from "../types";
import { BaseItemHeading } from "./BaseItemHeading";

export function ItemHeading(props: ItemProps) {
  return <BaseItemHeading {...props} />;
}
